import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Landing.css';
import { PUBLIC, GOLD, GOLD_LT, CREAM, INK, MAPS_URL } from '../theme';

// Served as WebP with a JPEG fallback — as a full-bleed background this is
// the heaviest asset on the page after the hero, and WebP costs 104KB against
// the JPEG's 281KB for the same crop. The 1.9MB PNG the photograph arrived as
// lives in assets-source/ so it never ships.
const BAND_WEBP = PUBLIC + '/assets/atelier-visit.webp';
const BAND_JPG = PUBLIC + '/assets/atelier-visit.jpg';
const BAND_FALLBACK = PUBLIC + '/assets/hero-palace.png';

// The only route to the primary action used to be the nav button, which
// disappears behind a hamburger on a phone. This puts booking in the scroll
// path, at the point where someone has just seen the pieces and the process.
export default function AppointmentBand() {
  const [src, setSrc] = useState(BAND_JPG);
  const [missing, setMissing] = useState(false);

  return (
    <section
      // The band is ~3:1 while the photograph is 1.78:1, so height decides how
      // much of the figure survives the crop — at the original padding-driven
      // height it cut her off at the neck. This keeps head and hem in frame and
      // centres the copy against her rather than floating it at the top.
      className="ij-band"
      style={{ position: 'relative', display: 'flex', alignItems: 'center', minHeight: 'clamp(480px,72vh,700px)', padding: 'clamp(60px,8vh,90px) clamp(24px,4vw,60px)', borderTop: '1px solid rgba(201,162,75,.2)', overflow: 'hidden', background: INK }}
    >
      <picture>
        {!missing && <source srcSet={BAND_WEBP} type="image/webp" />}
        <img
          src={src}
          alt=""
          className="ij-band-img"
          loading="lazy"
          // Missing assets are served index.html by the SPA catch-all rather
          // than a 404, so the image fails to decode instead of failing to
          // fetch — onError catches both. Dropping the <source> too, or the
          // browser would keep preferring a WebP that isn't there.
          onError={() => { setMissing(true); setSrc(BAND_FALLBACK); }}
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: '72% 18%' }}
        />
      </picture>
      {/* Lighter than the hero's scrim: this frame was shot with the left
          arcade already in shadow, so it only needs enough to seat the text —
          more would crush the jali screens and the arches, which are the
          reason to use this photograph at all. Direction flips on mobile;
          see .ij-band-scrim in Landing.css. */}
      <div className="ij-band-scrim" />

      <div style={{ position: 'relative', maxWidth: 620 }}>
        <div style={{ fontWeight: 600, fontSize: 14, letterSpacing: '.36em', textTransform: 'uppercase', color: GOLD_LT, marginBottom: 16 }}>V — Visit Us</div>
        <h2 style={{ fontFamily: "'Bodoni Moda', serif", fontWeight: 500, fontStyle: 'italic', fontSize: 'clamp(36px,5vw,64px)', lineHeight: 1, margin: '0 0 20px', color: CREAM, textShadow: '0 2px 24px rgba(0,0,0,.6)' }}>
          Come see the work in person
        </h2>
        <p style={{ fontSize: 18, lineHeight: 1.75, color: 'rgba(239,228,210,.82)', margin: '0 0 34px' }}>
          Embroidery this dense never photographs the way it looks in the room. Book a fitting at our F-7 atelier and we will walk you through the cloth, the handwork, and the timeline.
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
          <Link
            to="/book-appointment"
            style={{ fontWeight: 600, fontSize: 13, letterSpacing: '.2em', textTransform: 'uppercase', padding: '16px 32px', background: GOLD, color: INK, textDecoration: 'none' }}
          >
            Book an appointment
          </Link>
          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontWeight: 600, fontSize: 13, letterSpacing: '.2em', textTransform: 'uppercase', padding: '16px 32px', border: `1px solid ${GOLD}`, color: GOLD_LT, textDecoration: 'none' }}
          >
            F-7 Markaz, Islamabad
          </a>
        </div>
      </div>
    </section>
  );
}
